import { useEffect } from 'react';
import { getEmotionIconByPercentage } from '../../utils/emotionUtils';

interface DynamicFaviconProps {
  totalVotes: number;
  positiveVotes: number;
}

const DynamicFavicon = ({ totalVotes, positiveVotes }: DynamicFaviconProps) => {
  useEffect(() => {
    const updateFavicon = async () => {
      let positivePercentage = 50; // Por defecto, 50% (neutral/amarillo)
      
      if (totalVotes > 0) {
        positivePercentage = (positiveVotes / totalVotes) * 100;
      }
      
      const faviconSrc = getEmotionIconByPercentage(positivePercentage);

      if (!faviconSrc) {
        console.warn('No se pudo obtener el icono del favicon para el porcentaje:', positivePercentage);
        return;
      }

      const img = new Image();
      img.src = faviconSrc;

      await new Promise((resolve) => {
        img.onload = () => {
          const renderIcon = (size: number) => {
            const c = document.createElement('canvas');
            c.width = size;
            c.height = size;
            const cx = c.getContext('2d');
            if (!cx) return '';
            cx.drawImage(img, 0, 0, size, size);
            return c.toDataURL('image/png');
          };

          const favicon32 = renderIcon(32);
          const appleIcon = renderIcon(180);

          let iconLink = document.querySelector("link[rel='icon']") as HTMLLinkElement;
          if (!iconLink) {
            iconLink = document.createElement('link');
            iconLink.rel = 'icon';
            document.head.appendChild(iconLink);
          }
          iconLink.type = 'image/png';
          iconLink.href = favicon32;

          let appleLink = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement;
          if (!appleLink) {
            appleLink = document.createElement('link');
            appleLink.rel = 'apple-touch-icon';
            document.head.appendChild(appleLink);
          }
          appleLink.href = appleIcon;

          resolve(true);
        };
      });
    };

    updateFavicon();
  }, [totalVotes, positiveVotes]);

  return null;
};

export default DynamicFavicon; 